import {enumerate} from 'ts-transformer-enumerate';
import {keys} from 'ts-transformer-keys';


export type FormatType = 'DateTime' | 'Image' | 'Number' | 'Text';
export const formatTypes = enumerate<FormatType>();

type NormalFormat = {
    type : FormatType;
    prefix? : string;
    suffix? : string;
    locales? : string | string[];
    options? : { [ key : string ] : any };
    data? : { [ key : string ] : any };
};
const normalFormatProps = keys<NormalFormat>();

type CustomFormat = {
    type : 'Custom';
    fnc : ( inValue : string ) => string;
    prefix? : string;
    suffix? : string;
    data? : { [ key : string ] : any };
};
const customFormatProps = keys<CustomFormat>();

export type Format = NormalFormat | CustomFormat;
export const formatProps : string[] = ( normalFormatProps as string[] ).concat(
    ( customFormatProps as string[] ).reduce(
        ( retVal, entry ) => {
            if ( !( normalFormatProps as string[] ).includes( entry ) ) {
                retVal.push( entry );
            }

            return retVal;
        },
        [] as string[]
    )
);
